import { Container } from "react-bootstrap";
import { useHistory, useLocation } from 'react-router-dom';
import { useAppConfig } from 'srs.sharedcomponents/lib/esm/components/context/appConfig';
import Keyfinder from 'srs.sharedcomponents/lib/esm/components/organisms/KeyFinder/keyfinder';
import BreadcrumbComponent from 'srs.sharedcomponents/lib/esm/components/srs.breadcrumb.component';
import { useAppSelector } from 'srs.sharedcomponents/lib/esm/redux/hooks';
import { bearerToken } from 'srs.sharedcomponents/lib/esm/redux/slices/userSlice';
import { mainMenuItems } from 'srs.sharedcomponents/lib/esm/redux/slices/welcomeSlice';
import PageNotFoundComponent from "srs.sharedcomponents/lib/esm/shared-components/srs.notFoundPage.component";
import { stringToBoolean } from 'srs.sharedcomponents/lib/esm/utils/helpers';

const KeyFinderWrapper = () => {
     const userLoggedIn = !!useAppSelector(bearerToken);
      const mainMenu = useAppSelector(mainMenuItems);
    const { config } = useAppConfig();
    const history = useHistory();
    const { pathname } = useLocation();
    const fullWidthLayout = stringToBoolean(
        process.env.REACT_APP_FULL_WIDTH_LAYOUT
    );
    const hasKeyFinderInConfig = config?.categoryConfig?.some(
        (c: { category: string }) => c.category === "Keys"
    );

     if (!userLoggedIn) {
        history.push("/login");
    }

    if (
        userLoggedIn &&
        !mainMenu?.some((item) => item.name === "Key Finder") &&
        !hasKeyFinderInConfig && pathname.toLowerCase().includes("keyfinder")
    ) {
        return <PageNotFoundComponent />;
    }

    return (
        <>
              <Container fluid={fullWidthLayout}>
                <BreadcrumbComponent />
              </Container>
              <Keyfinder containerClassName="from-keyfinder" titleTextColor="#212529" searchButtonColor="#002469" />
        </>
    )
}


export default KeyFinderWrapper;